import { ZoomToVis } from "@/animations/ZoomToVis";
import { canv } from "@/canv/global";
import { eventEmitter } from "@/eventEmitter";

type FoundItems = ReturnType<typeof canv.canvasController.searchText>;

class SearchController {
    foundItems: FoundItems = [];
    position = 0;
    searchText = "";

    setFoundItems(foundItems: FoundItems) {
        this.foundItems = foundItems;

        this.setPosition(Math.max(Math.min(this.position, foundItems.length - 1), 0));
        canv.redraw();
    }

    reset() {
        this.searchText = "";
        this.setFoundItems([]);
    }

    inputSearch(value: string) {
        const searchText = value.toLowerCase().trim() || "";
        this.searchText = searchText;
        const foundItems = canv.canvasController.searchText(searchText);
        this.setFoundItems(foundItems);
    }

    setPosition(position: number) {
        if (position < 0 || position > this.foundItems.length - 1) {
            this.position = 0;
        } else {
            this.position = position;
        }

        eventEmitter.dispatch("search.results.update", {
            total: this.foundItems.length,
            currentIndex: this.position,
        });

        if (this.foundItems[this.position]) {
            this.zoomToTextWidget(this.foundItems[this.position]);
        }
    }

    zoomToTextWidget(itemInfo: (typeof this.foundItems)[number]) {
        let widgetProps = {
            startX: itemInfo.textWidget.startX,
            startY: itemInfo.textWidget.startY - itemInfo.textWidget.lineHeight,
            width: itemInfo.textWidget.width,
            height: itemInfo.textWidget.height,
        };

        if (itemInfo.mode === "widget") {
            widgetProps = {
                startX: itemInfo.group.startX,
                startY: itemInfo.group.startY,
                width: itemInfo.group.width,
                height: itemInfo.group.height,
            };
        }

        const viewProps = canv.getZoomToTransformations(widgetProps);

        const animation = new ZoomToVis(viewProps);
        canv.animator.deleteAnimation("zoomTo");
        canv.animator.addAnimation(animation);
        canv.redraw();
    }

    nextItem() {
        if (this.position + 1 >= this.foundItems.length) {
            this.setPosition(0);
            return;
        }
        this.setPosition(this.position + 1);
    }

    previousItem() {
        if (this.position < 1) {
            this.setPosition(this.foundItems.length - 1);
            return;
        }
        this.setPosition(this.position - 1);
    }

    draw() {
        for (let i = 0; i < this.foundItems.length; i++) {
            if (
                canv.canvasController.FindByUID(this.foundItems[i].group.UID) === null ||
                this.foundItems[i].group.onlyChild()?.constructorName === "frame"
            ) {
                continue;
            }

            this.foundItems[i].textWidget.highlightText(this.searchText);
        }
    }
}

export default new SearchController();
